const { request } = require('../../rest/index');
const endpoints = require('../../config/endpoints');

const InvalidCustomisationError = require('../../errors/InvalidCustomisationError');
const ProductRendererNotFoundError = require('../../errors/ProductRendererNotFoundError');

const fetchPreviewAssets = (productId, customisations) => {
  const params = customisations;
  const endpoint = endpoints.buildPreviewUrl(productId, params);

  return request.post(endpoint, params, {
    headers: {
      'content-type': 'application/json',
    },
  });
};

const renderProduct = async (productId, customisations) => {
  try {
    const params = customisations;
    const endpoint = endpoints.buildPreviewUrl(productId, params);

    return await request.post(endpoint, params, {
      headers: {
        'content-type': 'application/json',
      },
    });
  } catch (err) {
    switch (err.status) {
      case 400:
        throw new InvalidCustomisationError(err);
      case 404:
        throw new ProductRendererNotFoundError(err, productId);
      default:
        throw err;
    }
  }
};

const formatBody = (productId, response) => {
  let body = {};
  if (endpoints.isMu2(productId)) {
    body.images = response.body.toc.map(img => img.url);
  } else { //Only other is lost my name
    body = response.body;
  }
  return body;
};

module.exports = {
  fetchPreviewAssets,
  renderProduct,
  formatBody,
};
